module.exports = __webpack_public_path__ + "img/lentes.a1f3afac.svg";